import { Tooltip } from 'antd';
import { observer } from 'mobx-react-lite';
import { EllipsisContainer } from 'src/components/EllipsisContainer/EllipsisContainer';
import { MasterDetailsAsideItem } from 'src/components/MasterDetailsPage/MasterDetailsAsideItem';
import { EntityLinks } from 'src/core/router/EntityLinks';
import { Dashboard } from 'src/generated-api-client';

type DashboardListItemProps = { item: Dashboard };

export const DashboardListItem = observer(
    ({ item }: DashboardListItemProps) => {
        return (
            <MasterDetailsAsideItem
                small
                to={EntityLinks.metabaseDashboards.itemDetails(item.id)}
            >
                <Tooltip title={item?.name}>
                    <EllipsisContainer>{item?.name}</EllipsisContainer>
                </Tooltip>
            </MasterDetailsAsideItem>
        );
    },
);
